import { render, staticRenderFns } from "./ModalViewCredential.vue?vue&type=template&id=108f3313&scoped=true"
import script from "./ModalViewCredential.vue?vue&type=script&lang=js"
export * from "./ModalViewCredential.vue?vue&type=script&lang=js"
import style0 from "./ModalViewCredential.vue?vue&type=style&index=0&id=108f3313&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108f3313",
  null
  
)

export default component.exports